import axios from './axiosInstance';

export const subscriptionsList = async (params = {}) => {
  const response = await axios.get("/club_api/subscriptions", { params });
  return response.data;
};

export const subscriptionDetails = async (id) => {
  const response = await axios.get("/club_api/subscriptions/" + id);
  return response.data;
};

export const subscriptionUpdate = async (subscription = {}) => {
  const response = await axios.put("/club_api/subscriptions/" + subscription?.id, { subscription });
  return response.data;
};
